/**
 * Constants for notetaker/recap UI state (meeting intelligence).
 * Used by hooks/use_get_notetaker_toggle_state.js and hooks/use_notetaker_state.ts.
 */

/** Meeting intelligence event status enum */
export const EventStatus = {
  SCHEDULED: 'SCHEDULED',
  PRE_JOIN: 'PRE_JOIN',
  MEETING_IN_PROGRESS: 'MEETING_IN_PROGRESS',
  MEETING_ENDED: 'MEETING_ENDED',
  SUMMARIZING: 'SUMMARIZING',
  COMPLETED: 'COMPLETED',
  NO_ATTENDEES: 'NO_ATTENDEES',
  EMPTY_TRANSCRIPT: 'EMPTY_TRANSCRIPT',
  NOT_ENOUGH_CONTENT: 'NOT_ENOUGH_CONTENT',
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED'
}

/** Statuses that indicate recap is processing (not yet available) */
export const recapProcessingStateStatuses = [
  EventStatus.MEETING_ENDED,
  EventStatus.SUMMARIZING
]

/** Lowercase versions for case-insensitive comparison in use_get_notetaker_toggle_state */
export const recapProcessingStateStatusesFlat = recapProcessingStateStatuses.map((s) => s.toLowerCase())

/** Statuses that are retryable (toggle shows off, user can retry) */
export const retryableStatusesFlat = [
  'no_attendees',
  'error',
  'empty_transcript',
  'not_enough_content'
]

/** Error codes that show "no recap available" with a specific tooltip */
export const noRecapAvailableStateErrors = {
  HOST_RECORDING_PERMISSION_DENIED: 'host_recording_permission_denied',
  MEETING_BOT_REFUSED: 'meeting_bot_refused',
  MEETING_NOT_FOUND: 'meeting_not_found'
}

/** Statuses that show "no recap available" with a specific tooltip */
export const noRecapAvailableStateStatuses = {
  [EventStatus.NO_ATTENDEES]: 'no_attendees',
  [EventStatus.EMPTY_TRANSCRIPT]: 'empty_transcript',
  [EventStatus.NOT_ENOUGH_CONTENT]: 'not_enough_content'
}
